import { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import Logo from "../images/nav/logo.png";
import { handleBuyNowClick } from "../utils/deviceDetection";

const Nav = ({ data }) => {
  const { pathname } = useLocation();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    if (window.location.hash) {
      const el = document.querySelector(window.location.hash);
      el?.scrollIntoView({ behavior: "smooth" });
    }
  }, []);

  // Link definitions for easy maintenance
  const navLinks = [
    { name: "Home", path: "/", hash: "" },
    { name: "About us", path: "/", hash: "#aboutus" },
    { name: "Why choose us", path: "/", hash: "#choose_us" },
    { name: "Products", path: "/products" },
    { name: "Contact us", path: "/", hash: "#contact" },
  ];

  const getLinkClass = ({ isActive }) =>
    `pl-4 md:p-4 duration-200 cursor-pointer hover:text-[#998147] ${
      isActive ? "text-[#998147]" : "text-black"
    }`;

  const isLegalPage = pathname === "/privacy" || pathname === "/terms";

  const [showPlatformModal, setShowPlatformModal] = useState(false);

  const ANDROID_LINK = data?.appSection?.googlePlayLink || "#";
  const IOS_LINK = data?.appSection?.appStoreLink || "#";

  const handleDownloadClick = () => {
    handleBuyNowClick(ANDROID_LINK, IOS_LINK, setShowPlatformModal);
  };

  console.log({ data });

  return (
    <header className="z-50 fixed top-5 flex items-center justify-between px-8 py-0 md:py-2 shadow-[0px_2px_30px_4px_rgba(0,0,0,0.2)] w-[100%] md:w-[95%] md:ml-[2.6rem] lg:ml-[2.8rem] bg-white">
      {/* Logo */}
      <h1 className="w-6/12 sm:w-5/12 md:w-2/12">
        <Link to="/" className="flex items-center">
          <img
            className="w-[10rem] md:w-[100%] lg:w-[90%] h-[3rem] md:h-[4rem] object-contain hover:opacity-50 transition duration-300"
            src={Logo}
            alt="Logo"
          />
        </Link>
      </h1>

      <nav className="nav font-semibold text-sm md:text-xl">
        {/* Mobile Dropdown Button */}
        <div className="inline md:hidden relative">
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="gap-2 text-black focus:outline-none p-2"
            type="button"
          >
            <img
              className="w-10 h-10"
              src="https://img.icons8.com/external-others-amoghdesign/48/external-list-multimedia-solid-24px-others-amoghdesign.png"
              alt="menu"
            />
          </button>

          {isMobileMenuOpen && (
            <div className="z-10 absolute bg-[#d1d0d0] rounded-lg shadow-sm w-44 right-0 mt-2 py-2">
              {!isLegalPage ? (
                navLinks.map((link) => (
                  <Link
                    key={link.name}
                    to={link.hash || link.path}
                    onClick={() => setIsMobileMenuOpen(false)}
                    className="block px-4 py-2 hover:text-[#998147] text-black text-sm"
                  >
                    {link.name}
                  </Link>
                ))
              ) : (
                <a
                  href="#download"
                  className="block px-4 py-2 text-black text-sm"
                >
                  Download App
                </a>
              )}
            </div>
          )}
        </div>

        {/* Desktop Navigation */}
        {!isLegalPage && (
          <ul className="hidden md:flex md:items-center md:gap-6 lg:gap-16 text-lg text-black">
            {navLinks.map((link) => {
              const isActive = link.hash
                ? window.location.hash === link.hash && pathname === link.path
                : pathname === link.path;

              const handleClick = (e) => {
                if (link.hash) {
                  e.preventDefault();

                  if (pathname !== "/") {
                    window.location.href = "/" + link.hash;
                    return;
                  }

                  const element = document.querySelector(link.hash);
                  element?.scrollIntoView({ behavior: "smooth" });
                  window.location.hash = link.hash;
                }
              };
              return (
                <li key={link.name}>
                  <NavLink
                    onClick={handleClick}
                    to={link.hash || link.path}
                    className={`pl-4 md:p-4 duration-200 cursor-pointer hover:text-[#998147] ${
                      isActive ? "text-[#998147]" : "text-black"
                    }`}
                  >
                    {link.name}
                  </NavLink>
                </li>
              );
            })}
          </ul>
        )}
      </nav>

      {/* Download Button */}
      <div className="hidden md:w-2/12 md:grid justify-end">
        <button
          onClick={handleDownloadClick}
          className="md:w-[12rem] lg:w-[12rem] md:h-[2.5rem] text-white hover:text-[#998147] bg-gray-800 hover:bg-gray-900 transition duration-300 font-medium md:text-sm "
        >
          Download App
        </button>
      </div>

      {showPlatformModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center">
          <div
            className="absolute inset-0 bg-black opacity-40"
            onClick={() => setShowPlatformModal(false)}
          />
          <div className="bg-white rounded-xl p-6 z-10 w-full max-w-sm shadow-lg">
            <h3 className="text-lg font-bold text-[#15363A] mb-2">
              Download App
            </h3>
            <p className="text-sm text-gray-600 mb-4">
              Choose your platform to download the app.
            </p>
            <div className="flex gap-3">
              <a
                href={ANDROID_LINK}
                target="_blank"
                rel="noopener noreferrer"
                className="flex-1 px-4 py-3 bg-[#998147] text-white rounded-lg font-semibold text-center"
              >
                Android
              </a>
              <a
                href={IOS_LINK}
                target="_blank"
                rel="noopener noreferrer"
                className="flex-1 px-4 py-3 border border-gray-200 rounded-lg font-semibold text-center"
              >
                iOS
              </a>
            </div>
            <button
              onClick={() => setShowPlatformModal(false)}
              className="mt-4 w-full text-sm text-gray-600"
            >
              Cancel
            </button>
          </div>
        </div>
      )}
    </header>
  );
};

export default Nav;
